import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';

const MediumHeading = ({ children }) => (
  <StyledHeading>
    {children}
  </StyledHeading>
);

const StyledHeading = styled.h2`
  color: ${theme.colors.primary};
  font-size: 32px;
  font-weight: 400;
  line-height: 1.5;
`;

export default MediumHeading;